import React, { useEffect, useState, useMemo } from 'react';
import { Spinner } from 'reactstrap';
import { getDashboardTotals } from '../../../../helpers/water_rights/backend_helper';
import EChartsDoughnutChart from '../../../../Components/Common/Charts/ECharts/EChartsDoughnutChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const DashboardTotalsWidget = () => {
	const [data, setData] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		getDashboardTotals()
			.then(res => { if (!cancelled) setData(res); })
			.catch(() => {})
			.finally(() => { if (!cancelled) setIsLoading(false); });
		return () => { cancelled = true; };
	}, []);

	const options = useMemo(() => {
		const statusData = data?.water_rights_by_status || [];
		const total = data?.total_water_rights ?? 0;
		return {
			tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
			legend: { top: '5%', left: 'center' },
		color: generateColorGradient(statusData.length || 1),
			series: [{
				name: 'Estado DAA',
				type: 'pie',
				radius: ['40%', '70%'],
				avoidLabelOverlap: false,
				itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
				label: {
					show: true,
					position: 'center',
					formatter: () => `{total|${total}}\n{label|Total}`,
					rich: {
						total: { fontSize: 22, fontWeight: 'bold', color: '#333' },
						label: { fontSize: 12, color: '#888' },
					},
				},
				emphasis: { label: { show: true, fontSize: 18, fontWeight: 'bold' } },
				labelLine: { show: false },
				data: statusData.length
					? statusData.map(s => ({ value: s.count, name: s.status_name }))
					: [{ value: total || 1, name: 'Sin estado', itemStyle: { color: '#e8e8e8' } }],
			}],
		};
	}, [data]);

	if (isLoading) {
		return (
			<div className='d-flex justify-content-center align-items-center py-4'>
				<Spinner size='sm' />
			</div>
		);
	}

	return <EChartsDoughnutChart options={options} />;
};

export default DashboardTotalsWidget;
